import ChangeMethodModal from 'components/GlobalModals/ChangeMethodModal/ChangeMethodModal';
import { withRewardFulfillmentMethodModalProps } from 'viewModel/rewardFulfillmentMethodModal/withRewardFulfillmentMethodModalProps';

export default withRewardFulfillmentMethodModalProps(ChangeMethodModal);
